export interface FormElement {
  value: undefined | string | number | any;
  errors: Array<any>;
  touched: boolean;
}

export const formSchema = {
  feasibilityId: { value: undefined, errors: [], touched: false } as FormElement
};

export interface FeasibilityResponseType {
  feasibilityStatus: 'FEASIBLE' | 'MANUAL_INTERVENTION_REQUIRED' | 'PENDING' | 'EXPIRED';
  address: { addressString: string; city: string; pinCode: string };
  requestedBandwidth: number;
  product: string;
  requestCreateDate: string;
  message: string;
}

export interface CreateNewFeasibilityPayLoad {
  recommendedFeasibilityId: string;
  requestId: string;
  product: string;
  requestedBandwidth: number;
  customerDetails?: any;
  source: string;
  feature: string;
}
